import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Cookies } from 'react-cookie';
import en from './assets/locale/en.json';
import ru from './assets/locale/ru.json';

const cookies = new Cookies();

if (!cookies.get('language')) cookies.set('language', 'ru');

const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
};

await i18next.use(initReactI18next).init({
  resources,
  lng: cookies.get('language'),
  debug: false,
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  ns: 'translation',
  defaultNS: 'translation',
});

export default i18next;
